import React from "react";

const emptyResults = () => (
  <div className="card w-75 mx-auto mt-4">
    <div className="card-body">
      <div className="card-title">
        <h4 className="fw-bold">No experts found matching this search.</h4>
      </div>
      <hr />
      <p>
        Our expert database is a fraction of Qwoted&apos;s global expert network. Many of our users haven&apos;t taken
        the time to proactively create expert profiles for themselves, colleagues and clients. We almost always have an
        expert that can speak to you about the subject you&apos;re researching.
      </p>
      <div className="alert alert-info">
        The easiest way to reach them is to{" "}
        {/* V1 hosts this tree too and has no equivalent of /profiles/:id/my_requests/new, so the
            sentence stands there without a link. */}
        {globalThis.Qwoted?.V1_HOSTED ? (
          "create a request"
        ) : (
          <a href={`/profiles/${globalThis.Qwoted?.CURRENT_PROFILE_ID}/my_requests/new`} className="fw-bold">
            create a request
          </a>
        )}
        , which will only be delivered to relevant experts in our network.
      </div>
      <hr />
      <p className="text-info">
        <em>
          Still having trouble finding a expert?&nbsp;
          <a href={`mailto:${globalThis.Qwoted.SUPPORT_EMAIL}`} className="fw-bold">
            Get in touch
          </a>{" "}
          and one of our research assistants will be happy to help connect you with relevant experts.
        </em>
      </p>
    </div>
  </div>
);

export default emptyResults;
